import { useAiBuilderTypewriter } from '../hooks';

// 사고 과정은 답변 본문(기본 30cps)보다 살짝 빠르게 흘려보낸다.
const AI_BUILDER_THINKING_CHARS_PER_SEC = 80;

/**
 * 진행 중 카드 안에서 모델의 사고 과정(thinking_delta)을 단계 UI로 흘려보낸다.
 * 답변 본문 스트리밍과 동일한 useAiBuilderTypewriter 클럭을 재사용하되 속도만
 * 살짝 올린다. 구조는 진행 스텝(ProgressStepList)의 좌측 라인/인디케이터 패턴을 따른다.
 *
 * 답변이 시작되거나 턴이 끝나면 상위에서 thinkingText 자체가 제거되어 이 블록도
 * 언마운트된다(ephemeral).
 */
export const AiBuilderThinkingStream = ({
  text,
  enabled
}: {
  text: string;
  enabled: boolean;
}) => {
  const displayedText = useAiBuilderTypewriter({
    fullText: text,
    enabled,
    charsPerSecond: AI_BUILDER_THINKING_CHARS_PER_SEC
  });
  if (!displayedText) return null;
  return <div className="flex w-full flex-col items-start px-md" data-ai-assistant-thinking-slot data-sentry-component="AiBuilderThinkingStream" data-sentry-source-file="AiBuilderThinkingStream.tsx">
      <div className="flex min-w-0 max-w-full flex-col items-start border-l border-alternative">
        <div className="flex min-h-[32px] min-w-0 max-w-full items-start overflow-hidden rounded-full text-body-md-semibold text-neutral">
          <div className="flex min-w-0 items-start justify-center px-sm py-2xs">
            <p className="min-w-0 whitespace-pre-wrap break-words text-left">
              {displayedText}
            </p>
          </div>
        </div>
      </div>
    </div>;
};